/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from "react";
import CustomerService from "../../services/CustomerService";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import "react-toastify/dist/ReactToastify.css";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Lodder from "../../components/Lodder";
import { notification } from "antd";
import Cookies from "js-cookie";
import {
  UserOutlined,
  LockOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
};
const Login = () => {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    document.title = "Foundry Law - Login";
  }, []);
  useEffect(() => {
    let accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      navigate("/dashboard");
    } else if (Cookies.get("userEmail") && Cookies.get("password")) {
      setEmail(Cookies.get("userEmail"));
      setPassword(Cookies.get("password"));
    } else {
      setEmail("");
      setPassword("");
    }
  }, []);
  const handleRegister = () => {
    navigate("/register");
  };
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    const encryptedUserData = CryptoJS.AES.encrypt(
      JSON.stringify(userData),
      process.env.REACT_APP_SECRET_KEY
    ).toString();
    const encryptedQueryParam = encodeURIComponent(encryptedUserData);
    navigate(`/payment/${encryptedQueryParam}`);
  };
  const [userData, setUserData] = useState("");
  const [submit, setSubmit] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailValidation, setEmailValidation] = useState({
    isValid: false,
    message: "",
  });
  const [passwordValidation, setPasswordValidation] = useState({
    isValid: false,
    message: "",
  });
  const IsValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  const ValidateEmail = (value) => {
    if (!value.trim()) {
      setEmailValidation({ isValid: false, message: "Email is required" });
    } else if (value.length > 100) {
      setEmailValidation({
        isValid: false,
        message: "Email not more than 50 characters",
      });
    } else if (!IsValidEmail(value)) {
      setEmailValidation({
        isValid: false,
        message: "Please enter a valid email",
      });
    } else {
      setEmailValidation({
        isValid: true,
        message: "",
      });
    }
  };
  const ValidatePassword = (value) => {
    if (!value.trim()) {
      setPasswordValidation({
        isValid: false,
        message: "Password is required",
      });
    } /* else if (value.length < 6) {
      setPasswordValidation({
        isValid: false,
        message: "Password must be at least 6 characters",
      });
    }  */ else {
      setPasswordValidation({
        isValid: true,
        message: "",
      });
    }
  };
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    ValidateEmail(event.target.value);
  };
  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    ValidatePassword(event.target.value);
  };
  const handleFormSubmit = () => {
    setSubmit(false);
    // eslint-disable-next-line no-restricted-globals
    event.preventDefault();
    ValidateEmail(email);
    ValidatePassword(password);
    if (emailValidation.isValid && passwordValidation.isValid) {
      var customerCredentials = {
        email: email,
        password: password,
      };
      CustomerService.LoginCustomer(customerCredentials)
        .then((response) => {
          if (response.status) {
            localStorage.setItem("accessToken", response.resultData.token);
            if (isChecked) {
              Cookies.set("userEmail", email, { expires: 14 });
              Cookies.set("password", password, { expires: 14 });
            }
            setEmail("");
            setPassword("");
            navigate("/dashboard", { replace: true });
          }
        })
        .catch((error) => {
          /* toast.error(error.response.data.Message); */
          notification.error({
            message: error.response.data.Message,
          });
          setSubmit(true);
        });
      /* CustomerService.GetCustomerPaymentStatus(customerCredentials)
        .then((response) => {
          if (response.status) {
            if (!response.resultData.paymentStatus) {
              setUserData({
                email: email,
                password: password,
                userId: response.resultData.id,
              });
              handleOpen();
            } else {
              CustomerService.LoginCustomer(customerCredentials)
                .then((response) => {
                  if (response.status) {
                    localStorage.setItem(
                      "accessToken",
                      response.resultData.token
                    );
                    setEmail("");
                    setPassword("");
                    navigate("/dashboard", { replace: true });
                  }
                })
                .catch((error) => {
                  toast.error(error.response.data.Message);
                  setSubmit(true);
                });
            }
          }
        })
        .catch((error) => {
          toast.error(error.response.data.Message);
          setSubmit(true);
        }); */
    } else {
      setSubmit(true);
    }
  };
  return (
    <>
      <ToastContainer />
      <div className="vh-100 d-flex justify-content-center align-items-center flex-column px-3 login-bg login-form">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12">
              <figure className="text-center mx-auto mb-0">
                <img
                  src="/logo-dark.png"
                  className="img-fluid"
                  alt="foundary logo"
                  style={{ width: 138 }}
                />
              </figure>
            </div>
          </div>
        </div>
        <div className="mx-auto card mt-2">
          <div className="card-body">
            <div className="row">
              <div className="col-12 text-center">
                <h5 className="card-heading mb-0">Welcome!</h5>
                <p className="card-title mb-4 w-100">
                  Please sign in to your account below.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <form>
                  <input type="hidden" />
                  <div className="mb-4">
                    <label className="form-label" htmlFor="email">
                      Email
                    </label>
                    <div style={{ position: "relative" }}>
                      <input
                        className="form-control custom-input"
                        type="email"
                        value={email}
                        onChange={handleEmailChange}
                        style={{ padding: "0.375rem 2.75rem" }}
                      />
                      <UserOutlined
                        style={{
                          border: "none",
                          position: "absolute",
                          top: "15px",
                          left: "17px",
                        }}
                      />
                      {/* <i class="fa-solid fa-user" style={{position:'absolute',top:'11px',left:'17px'}}></i> */}
                    </div>
                    {!emailValidation.isValid && (
                      <span style={{ color: "red" }}>
                        {emailValidation.message}
                      </span>
                    )}
                  </div>
                  <div className="mb-4">
                    <label className="form-label" htmlFor="password">
                      Password
                    </label>
                    <div style={{ position: "relative" }}>
                      <input
                        className="form-control custom-input"
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={handlePasswordChange}
                        style={{ padding: "0.375rem 2.75rem" }}
                      />
                      {showPassword ? (
                        <EyeOutlined
                          onClick={() => {
                            setShowPassword(!showPassword);
                          }}
                          style={{
                            position: "absolute",
                            top: "15px",
                            right: "11px",
                          }}
                        />
                      ) : (
                        <EyeInvisibleOutlined
                          onClick={() => {
                            setShowPassword(!showPassword);
                          }}
                          style={{
                            position: "absolute",
                            top: "15px",
                            right: "11px",
                          }}
                        />
                      )}
                      {/*                       <i className={showPassword?"fa-solid fa-eye-slash":"fa-solid fa-eye"} style={{position:'absolute',top:'11px',right:'11px'}} onClick={()=>{setShowPassword(!showPassword)}}></i> */}
                      <LockOutlined
                        class="fa-solid fa-lock"
                        style={{
                          position: "absolute",
                          top: "15px",
                          left: "17px",
                        }}
                      ></LockOutlined>
                    </div>
                    {!passwordValidation.isValid && (
                      <span style={{ color: "red" }}>
                        {passwordValidation.message}
                      </span>
                    )}
                  </div>
                  <div className="mb-4 d-flex justify-content-between align-items-center">
                    <div className="form-check d-flex align-items-center">
                      <input
                        className="form-check-input me-2"
                        type="checkbox"
                        defaultValue=""
                        id="flexCheckDefault"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                      />
                      <label
                        className="form-check-label mb-0 pt-0"
                        htmlFor="remember_me"
                      >
                        Keep me logged in
                      </label>
                    </div>
                    <Link className="forgot-link" to="/forgetpassword">
                    Forgot Password
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="card-footer bg-secondary-subtle border-0 d-flex justify-content-between align-items-center">
            <Link type="submit" className="forgot-link" to="/register" onClick={()=>{localStorage.removeItem('Data')}}>
              Don't have an account yet? Register.
            </Link>
            <button
              type="submit"
              className="btn btn-primary d-block submit-button ml-auto"
              onClick={handleFormSubmit}
            >
              LOG IN
            </button>
          </div>
        </div>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Please complete your payment first
          </Typography>
          <Typography
            className="text-end"
            id="modal-modal-description"
            sx={{ mt: 2 }}
          >
            <button className="btn-submit-secondary btn" onClick={handleClose}>
              OK
            </button>
          </Typography>
        </Box>
      </Modal>
      <Lodder show={!submit} />
    </>
  );
};
export default Login;
